import React, { useEffect, useMemo, useState } from "react";
import { Col, Row, Card, CardBody, Badge, Button, Spinner, Alert } from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { fetchUserNames, fetchIlanNames } from "../../../helpers/lookupNames";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const fmtDate = (v) => (v ? new Date(v).toLocaleString("tr-TR") : "—");

const IlanFiyatAlarmlari = () => {
  document.title = "İlan Fiyat Alarmları | HarmanaGEL";

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };

  const [liste, setListe] = useState([]);
  const [ilanMap, setIlanMap] = useState({});
  const [userMap, setUserMap] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const fetchListe = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await fetch(`${BASE_URL}/ILAN_FIYAT_ALARMLARI?$orderby=ID desc&$top=1000`, { headers });
      const result = await res.json();
      const rows = result.value || [];
      setListe(rows);
      const [iMap, uMap] = await Promise.all([
        fetchIlanNames(rows.map((r) => r.ILAN_ID)),
        fetchUserNames(rows.map((r) => r.KULLANICI_ID)),
      ]);
      setIlanMap(iMap);
      setUserMap(uMap);
    } catch {
      setError("Fiyat alarmları yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchListe(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Bu fiyat alarmını silmek istediğinize emin misiniz?")) return;
    try {
      await fetch(`${BASE_URL}/ILAN_FIYAT_ALARMLARI(${id})`, { method: "DELETE", headers });
      setSuccessMsg("Fiyat alarmı silindi.");
      fetchListe();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("Silme sırasında hata oluştu.");
    }
  };

  const columns = useMemo(() => [
    { header: "#", accessorKey: "ID", enableSorting: true, cell: (c) => <strong>#{c.getValue()}</strong> },
    {
      header: "İlan", accessorKey: "ILAN_ID", enableSorting: true,
      cell: (c) => <span className="fw-medium">{ilanMap[c.getValue()] || `İlan #${c.getValue()}`}</span>,
    },
    {
      header: "Kullanıcı", accessorKey: "KULLANICI_ID", enableSorting: true,
      cell: (c) => <span>{userMap[c.getValue()] || `Kullanıcı #${c.getValue()}`}</span>,
    },
    {
      header: "Oluşturma Tarihi", accessorKey: "OLUSTURMA_TARIHI", enableSorting: true,
      cell: (c) => <small className="text-muted">{fmtDate(c.getValue())}</small>,
    },
    {
      header: "Durum", accessorKey: "AKTIF", enableSorting: true,
      cell: (c) => {
        const v = c.getValue();
        const aktif = v === true || v === "true" || v === 1 || v === "1";
        return <Badge color={aktif ? "success" : "secondary"}>{aktif ? "Aktif" : "Pasif"}</Badge>;
      },
    },
    {
      header: "İşlemler", enableSorting: false,
      cell: (cellProps) => (
        <Button color="danger" size="sm" outline onClick={() => handleDelete(cellProps.row.original.ID)}>
          <i className="bx bx-trash" />
        </Button>
      ),
    },
  ], [ilanMap, userMap]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="İlan Yönetimi" breadcrumbItem="İlan Fiyat Alarmları" />
          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <div>
                      <h4 className="card-title mb-1">İlan Fiyat Alarmları</h4>
                      <p className="text-muted small mb-0">
                        Kullanıcıların fiyat düşüşü için takibe aldığı ilanlar. Toplam {liste.length} kayıt.
                      </p>
                    </div>
                    <Button color="primary" size="sm" onClick={fetchListe} disabled={isLoading}>
                      <i className="bx bx-refresh" /> Yenile
                    </Button>
                  </div>
                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={liste}
                      isGlobalFilter={true}
                      isPagination={true}
                      customPageSize={15}
                      SearchPlaceholder="Ara..."
                      tableClass="align-middle table-nowrap table-hover"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      pagination="pagination pagination-rounded justify-content-end mb-2"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default IlanFiyatAlarmlari;
